import React from 'react';
import { Route } from 'react-router';
export default (
  <Route
    path="departmentnews/management"
    getComponent={(location, cb) => {
      require.ensure([], (require) => {
        cb(null, require('./index'));
      });
    }}
  />
);



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/DepartmentNews/screens/AnnouncementManagement/router.js
 **/